import { get, patch, post, remove } from '@/api/base'

const routeTemplatesApi = {
  get: async routeTemplateUuid => {
    const response = await get({ path: `route_templates/${routeTemplateUuid}` })
    return response.success ? response.data.route_template : null
  },
  evaluate: async evaluate_details => {
    const response = await get({
      path: `route_templates/evaluate`,
      params: evaluate_details,
    })
    return response.success ? response.data : null
  },
  getAllForCompany: async companyUuid => {
    const response = await get({
      path: `route_templates`,
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data.route_templates : []
  },
  update: async (routeTemplateUuid, updateDetails) => {
    return await patch({
      path: `route_templates/${routeTemplateUuid}`,
      params: updateDetails,
    })
  },
  create: async createDetails => {
    return await post({
      path: `route_templates/`,
      params: createDetails,
    })
  },
  delete: async routeTemplateUuid => {
    return await remove({
      path: `route_templates/${routeTemplateUuid}`,
    })
  },
}

export default routeTemplatesApi
